var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", class: { "oc-fullscreen": _vm.is_fullscreen } },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center flex-wrap mb-4" },
        [
          _c(
            "span",
            { staticClass: "text-uppercase text-h6 font-weight-regular" },
            [_vm._v(_vm._s(_vm.title))]
          ),
          _c("v-spacer"),
          _c("v-text-field", {
            staticClass: "mr-6",
            staticStyle: { "max-width": "420px" },
            attrs: {
              "append-icon": "search",
              placeholder: "Buscar puesto o persona",
              "single-line": "",
              "hide-details": "",
              dense: "",
            },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _c(
            "v-btn",
            {
              attrs: {
                outlined: "",
                small: "",
                icon: "",
                tile: "",
                color: "blue-grey",
                title: "Alejar",
                disabled: _vm.zoom <= _vm.ZOOM_MIN,
              },
              on: {
                click: function ($event) {
                  return _vm.setZoom(_vm.zoom - _vm.ZOOM_STEP)
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v("remove")])],
            1
          ),
          _c("span", { staticClass: "oc-toolbar-zoom" }, [
            _vm._v(_vm._s(Math.round(_vm.zoom * 100)) + "%"),
          ]),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: {
                outlined: "",
                small: "",
                icon: "",
                tile: "",
                color: "blue-grey",
                title: "Acercar",
                disabled: _vm.zoom >= _vm.ZOOM_MAX,
              },
              on: {
                click: function ($event) {
                  return _vm.setZoom(_vm.zoom + _vm.ZOOM_STEP)
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v("add")])],
            1
          ),
          _c(
            "v-btn",
            {
              attrs: {
                outlined: "",
                small: "",
                icon: "",
                tile: "",
                color: "blue-grey",
                title: _vm.is_fullscreen
                  ? "Salir de pantalla completa"
                  : "Pantalla completa",
              },
              on: { click: _vm.toggleFullscreen },
            },
            [
              _c("v-icon", { attrs: { small: "" } }, [
                _vm._v(
                  _vm._s(_vm.is_fullscreen ? "fullscreen_exit" : "fullscreen")
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "oc-canvas",
          on: {
            dragover: function ($event) {
              $event.preventDefault()
              return (() => {}).apply(null, arguments)
            },
          },
        },
        [
          _vm.loading
            ? _c(
                "div",
                { staticClass: "text-center pa-10" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "primary" },
                  }),
                ],
                1
              )
            : _vm.tree.length == 0
            ? _c(
                "v-alert",
                { staticClass: "ma-4", attrs: { type: "info", outlined: "" } },
                [
                  _vm._v(
                    "No hay puestos para mostrar. Cree un puesto o importe la estructura."
                  ),
                ]
              )
            : _c(
                "div",
                { staticClass: "oc-chart", style: { zoom: _vm.zoom } },
                _vm._l(_vm.tree, function (node) {
                  return _c("OrgChartNode", {
                    key: node.id,
                    attrs: { node: node, depth: 0 },
                  })
                }),
                1
              ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-flex align-center flex-wrap mt-4" },
        [
          _c(
            "div",
            { staticClass: "oc-legend" },
            [
              _vm._l(_vm.legend_items, function (legend) {
                return _c(
                  "span",
                  { key: legend.style, staticClass: "oc-legend-item" },
                  [
                    _c("span", {
                      staticClass: "oc-swatch",
                      class: legend.style,
                    }),
                    _vm._v(_vm._s(legend.name)),
                  ]
                )
              }),
              _vm._m(0),
            ],
            2
          ),
          _c("v-spacer"),
          _vm.update_access
            ? _c(
                "span",
                { staticClass: "text-caption grey--text text--darken-1" },
                [
                  _vm._v(
                    "Arrastre un puesto sobre otro para cambiar su dependencia"
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "oc-legend-item" }, [
      _c("span", { staticClass: "oc-swatch vacant" }),
      _vm._v("Vacante"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }